// extracted by mini-css-extract-plugin
export default {"mobileMenu":"style_mobileMenu__vQxCZ","handler":"style_handler__25023","handlerIcon":"style_handlerIcon__mMd1K"};